import AbstractEntity from "../AbstractEntity";

export default class Address extends AbstractEntity {
    _id;
    _line1;
    _line2;
    _line3;
    _postcode;
    _city;
    _lat;
    _lng;
    _orderId;


    getId() {
        return this._id;
    }

    getLine1() {
        return this._line1;
    }

    getLine2() {
        return this._line2;
    }

    getLine3() {
        return this._line3;
    }

    getPostcode() {
        return this._postcode;
    }

    getCity() {
        return this._city;
    }

    getLat() {
        return this._lat;
    }

    getLng() {
        return this._lng;
    }

    getOrderId() {
        return this._orderId;
    }

    getClassName() {
        return "address";
    }
}